import { createSelector } from 'reselect';
import { getPropertyLinkQuery } from './getPropertyLinkQuery';
import createSearchQueryString from 'lib/search/createSearchQueryString';

export const getPropertyLinkQueryString = createSelector(getPropertyLinkQuery, (query) => createSearchQueryString(query));
